import React, { Component } from "react";
import Autocomplete from "react-autocomplete";
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class TextAutocompleteInput extends Component {

  render() {
    return (
      <div className="auto-complete__wrapper" >
        <Autocomplete
          ref={ref => this.input = ref}
          getItemValue={item => this.props.itemValue(item)}
          menuStyle={{position: "absolute", left: "0px", top: this.props.inputHeight, maxHeight: "500px", overflowY: "scroll"}}
          items={this.props.items}
          renderItem={(item, isHighlighted) => (
            <div
              key={this.props.itemKey(item)}
              className="suggestion"
              style={{ background: isHighlighted ? "lightgray" : "white" }}
            >
              {this.props.itemLabel(item)}
            </div>
          )}
          autoHighlight={true}
          inputProps={{
            placeholder: this.props.placeholder,
          }}
          value={this.props.value}
          onChange={e => {
            this.props.onChange(e.target.value)
          }}
          onSelect={(val, item) => this.props.onSelect(val,item)}
        />
      </div>
    );
  }
}

export default TextAutocompleteInput;




// WEBPACK FOOTER //
// ./src/components/TextAutocompleteInput.js